export function Footer() {
  return (
    <footer className="border-t border-line">
      <div className="container-page flex flex-col items-start justify-between gap-6 py-10 md:flex-row md:items-center">
        <div>
          <p className="font-display text-lg text-ink">Callback</p>
          <p className="mt-1 text-sm text-ink-soft">Never lose a customer to a missed call.</p>
        </div>
        <div className="flex gap-8 text-sm text-ink-soft">
          <a href="#features" className="hover:text-ink">
            Features
          </a>
          <a href="#pricing" className="hover:text-ink">
            Pricing
          </a>
          <a href="#faq" className="hover:text-ink">
            FAQ
          </a>
        </div>
        <p className="text-xs text-ink-soft">© {new Date().getFullYear()} Callback. All rights reserved.</p>
      </div>
    </footer>
  );
}
